<!-- <a class="navbar-brand me-0 p-3" href="javascript:void(0);">
	<span class="logo-icon">
		<svg viewBox="0 0 48 48">
			<g>
				<path style="fill:#FFFFFF;" d="M44.5,19.2h-3.3c-0.4-1.5-0.9-2.8-1.7-4.1l2.4-2.4c0.6-0.6,0.6-1.5,0-2l-4.6-4.6c-0.6-0.6-1.5-0.6-2,0
					l-2.4,2.4c-1.3-0.7-2.6-1.3-4.1-1.7V3.5c0-0.9-0.7-1.5-1.5-1.5h-6.5c-0.9,0-1.5,0.7-1.5,1.5v3.3c-1.5,0.4-2.8,0.9-4.1,1.7l-2.4-2.2
					c-0.6-0.6-1.5-0.6-2,0l-4.6,4.6c-0.6,0.6-0.6,1.5,0,2l2.4,2.4c-0.7,1.3-1.3,2.6-1.7,4.1H3.6c-0.7,0-1.5,0.7-1.5,1.5v6.5
					c0,0.7,0.7,1.5,1.5,1.5H7c0.4,1.5,0.9,2.8,1.7,4.1l-2.4,2.2c-0.6,0.6-0.6,1.5,0,2l4.6,4.6c0.6,0.6,1.5,0.6,2,0l2.4-2.4
					c0.9,0.6,1.7,0.9,2.6,1.1v-7.9c-2.8-1.8-4.4-5.2-4.4-8.7c0-5.9,4.8-10.5,10.5-10.5s10.5,4.8,10.5,10.5c0,3.5-1.8,6.8-4.4,8.7v7.9
					c0.9-0.4,1.8-0.7,2.6-1.3l2.4,2.4c0.6,0.6,1.5,0.6,2,0l4.6-4.6c0.6-0.6,0.6-1.5,0-2l-2.4-2.4c0.7-1.3,1.3-2.6,1.7-4.1h3.3
					c0.9,0,1.5-0.7,1.5-1.5v-6.5C46,19.9,45.2,19.2,44.5,19.2z" />
				<path style="fill:#FF3366;" d="M30.3,23.8c0-2.2-1.1-4.1-2.8-5.2c-0.4-0.4-1.1,0-1.1,0.6v3.1c0,1.3-1.1,2.4-2.4,2.4c-1.3,0-2.4-1.1-2.4-2.4
					v-3.1c0-0.6-0.6-0.9-1.1-0.6c-1.7,1.1-2.8,3-2.8,5.2c0,2.4,1.5,4.6,3.5,5.5v13.9c0,1.5,1.3,2.8,2.8,2.8c1.5,0,2.8-1.3,2.8-2.8V29.4
					C28.8,28.4,30.3,26.4,30.3,23.8z" />
			</g>
		</svg>
	</span>
	<span class="logo-name">
		<svg viewBox="0 0 106 28.1">
			<g>
				<g>
					<path style="fill:#FFFFFF;" d="M16.5,9V6.9h2.1V9H16.5z" />
					<path style="fill:#FFFFFF;" d="M32,7.3h2.3V12c-1.3,1.4-3.1,2.1-5.5,2.1c-2,0-3.7-0.7-5.1-2s-2-3-2-5s0.7-3.7,2.1-5.1c1.4-1.4,3.1-2,5-2
						c2,0,3.6,0.6,4.9,1.7l-1.2,1.8C32.1,3,31.5,2.7,31,2.6c-0.5-0.2-1.2-0.3-1.9-0.3c-1.4,0-2.5,0.4-3.5,1.3c-0.9,0.9-1.4,2.1-1.4,3.5
						c0,1.5,0.5,2.6,1.4,3.5s2,1.3,3.3,1.3s2.4-0.3,3.3-0.8V7.3C32.1,7.3,32,7.3,32,7.3z" />
					<path style="fill:#FFFFFF;" d="M39.3,10.8l-1.4,3.1h-2.5l6-13.7h2.5l6,13.7h-2.5L46,10.8H39.3z M45,8.7l-2.5-5.6L40,8.7
						C40,8.7,45,8.7,45,8.7z" />
					<path style="fill:#FFFFFF;" d="M62.6,4.7c0,2.3-1,3.7-3,4.3l3.6,5h-2.9L57,9.4h-3V14h-2.3V0.3h5.1c2.1,0,3.6,0.4,4.5,1.1
						C62.3,2,62.6,3.1,62.6,4.7z M59.5,6.6c0.5-0.4,0.7-1.1,0.7-1.9c0-0.9-0.2-1.5-0.7-1.8S58.2,2.4,57,2.4H54v4.9H57
						C58.3,7.2,59.1,7,59.5,6.6z" />
					<path style="fill:#FFFFFF;" d="M67.9,10.8l-1.4,3.1h-2.5l6-13.7h2.5l6,13.7h-2.5l-1.3-3.1H67.9z M73.9,8.7l-2.5-5.6l-2.5,5.6
						C68.9,8.7,73.9,8.7,73.9,8.7z" />
					<path style="fill:#FFFFFF;" d="M89.9,7.3h2.3V12c-1.3,1.4-3.1,2.1-5.5,2.1c-2,0-3.7-0.7-5.1-2c-1.4-1.3-2-3-2-5s0.7-3.7,2.1-5.1
						c1.4-1.4,3.1-2,5-2c2,0,3.6,0.6,4.9,1.7l-1.2,1.8c-0.5-0.5-1.1-0.8-1.6-0.9c-0.5-0.2-1.2-0.3-1.9-0.3c-1.4,0-2.5,0.4-3.5,1.3
						c-0.9,0.9-1.4,2.1-1.4,3.5c0,1.5,0.5,2.6,1.4,3.5c0.9,0.9,2,1.3,3.3,1.3s2.4-0.3,3.3-0.8L89.9,7.3L89.9,7.3z" />
					<path style="fill:#FFFFFF;" d="M104.8,0.3v2.2h-7.3v3.6h6.5v2.1h-6.5v3.7h7.5v2.2h-9.8V0.3H104.8z" />
				</g>
				<g style="opacity:0.74;">
					<path style="fill:#FFFFFF;" d="M52.6,26h-2.8v-6.5h2.5c0.4,0,0.8,0.1,1.1,0.2c0.3,0.1,0.6,0.2,0.7,0.4c0.3,0.3,0.4,0.7,0.4,1.1
						c0,0.5-0.2,0.9-0.5,1.1c-0.1,0.1-0.2,0.1-0.2,0.2c0,0-0.1,0.1-0.2,0.1c0.4,0.1,0.7,0.3,1,0.5c0.2,0.3,0.4,0.6,0.4,1
						c0,0.5-0.2,0.9-0.5,1.2C54.1,25.8,53.5,26,52.6,26z M51,22.2h1.4c0.8,0,1.2-0.3,1.2-0.8c0-0.3-0.1-0.5-0.3-0.7
						c-0.2-0.1-0.5-0.2-0.9-0.2h-1.4C51,20.4,51,22.2,51,22.2z M51,24.8h1.7c0.4,0,0.7-0.1,0.9-0.2c0.2-0.1,0.3-0.4,0.3-0.7
						c0-0.6-0.5-0.9-1.4-0.9h-1.6L51,24.8L51,24.8z" />
					<path style="fill:#FFFFFF;"
						d="M56.8,27.9c-0.5,0-0.9-0.2-1.2-0.5l0.5-0.8c0.2,0.2,0.4,0.3,0.7,0.3c0.2,0,0.4-0.1,0.6-0.3
						c0.1-0.2,0.2-0.3,0.2-0.5c0-0.1-0.7-1.8-2-5.1h1.1l1.5,3.6l1.5-3.6h1.1l-2.4,5.9c-0.1,0.3-0.3,0.6-0.6,0.8S57,27.9,56.8,27.9z" />
					<path style="fill:#FFFFFF;" d="M68.6,20c0.5,0.4,0.7,1,0.7,1.8s-0.2,1.4-0.7,1.8s-1.2,0.6-2.1,0.6h-0.9V26h-1.4v-6.5h2.3
						C67.4,19.5,68.1,19.7,68.6,20z M67.4,22.5c0.2-0.2,0.3-0.5,0.3-0.9s-0.1-0.6-0.3-0.8c-0.2-0.2-0.6-0.2-1.1-0.2h-0.8v2.3h1
						C66.9,22.9,67.2,22.8,67.4,22.5z" />
					<path style="fill:#FFFFFF;" d="M72.9,22.2c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.3-0.3,0.7-0.3,1.2V26h-1.4v-5h1.4v0.7c0.2-0.2,0.4-0.4,0.7-0.5
						c0.3-0.1,0.5-0.2,0.8-0.2v1.3L72.9,22.2C72.9,22.3,72.9,22.2,72.9,22.2z" />
					<path style="fill:#FFFFFF;" d="M78.9,23.5c0,0.7-0.3,1.3-0.8,1.8c-0.5,0.5-1.1,0.7-1.9,0.7s-1.4-0.2-1.9-0.7s-0.8-1.1-0.8-1.8
						s0.3-1.3,0.8-1.8s1.1-0.7,1.9-0.7s1.4,0.2,1.9,0.7C78.6,22,78.9,22.7,78.9,23.5z M75.1,23.5c0,0.4,0.1,0.7,0.3,1
						c0.2,0.3,0.5,0.4,0.9,0.4c0.4,0,0.7-0.1,0.9-0.4c0.2-0.3,0.3-0.6,0.3-1s-0.1-0.7-0.3-1c-0.2-0.3-0.5-0.4-0.9-0.4
						c-0.4,0-0.7,0.1-0.9,0.4C75.1,22.7,75.1,23,75.1,23.5z" />
					<path style="fill:#FFFFFF;" d="M82.9,20.9c0.6,0,1.1,0.2,1.6,0.7s0.7,1.1,0.7,1.8s-0.2,1.4-0.7,1.8c-0.5,0.5-1,0.7-1.6,0.7
						c-0.6,0-1.1-0.2-1.5-0.7v2.6h-1.4V21h1.4v0.6C81.8,21,82.2,20.9,82.9,20.9z M81.4,23.5c0,0.4,0.1,0.7,0.3,1
						c0.2,0.3,0.5,0.4,0.8,0.4s0.6-0.1,0.8-0.4c0.2-0.3,0.4-0.6,0.4-1s-0.1-0.7-0.4-1c-0.2-0.3-0.5-0.4-0.8-0.4s-0.6,0.1-0.8,0.4
						C81.4,22.8,81.4,23,81.4,23.5z" />
					<path style="fill:#FFFFFF;"
						d="M90.4,25.2c-0.6,0.5-1.2,0.8-2,0.8s-1.4-0.2-1.9-0.7s-0.7-1.1-0.7-1.9s0.3-1.4,0.8-1.9s1.1-0.7,1.8-0.7
						c0.7,0,1.3,0.2,1.7,0.6c0.5,0.4,0.7,1,0.7,1.7v0.7h-3.6c0,0.3,0.2,0.5,0.4,0.7c0.2,0.2,0.5,0.3,0.8,0.3c0.5,0,0.9-0.2,1.2-0.5
						L90.4,25.2z M89.1,22.3c-0.2-0.2-0.4-0.2-0.7-0.2s-0.5,0.1-0.8,0.3c-0.2,0.2-0.4,0.4-0.4,0.7h2.2C89.4,22.7,89.2,22.4,89.1,22.3z" />
					<path style="fill:#FFFFFF;" d="M93.2,26h-1.4v-6.9h1.4V26z" />
					<path style="fill:#FFFFFF;" d="M95.9,26h-1.4v-6.9h1.4V26z" />
					<path style="fill:#FFFFFF;"
						d="M101.6,25.2c-0.6,0.5-1.2,0.8-2,0.8s-1.4-0.2-1.9-0.7S97,24.2,97,23.4s0.3-1.4,0.8-1.9s1.1-0.7,1.8-0.7
						s1.3,0.2,1.7,0.6c0.5,0.4,0.7,1,0.7,1.7v0.7h-3.6c0,0.3,0.2,0.5,0.4,0.7s0.5,0.3,0.8,0.3c0.5,0,0.9-0.2,1.2-0.5L101.6,25.2z
						 M100.2,22.3c-0.2-0.2-0.4-0.2-0.7-0.2s-0.5,0.1-0.8,0.3c-0.2,0.2-0.4,0.4-0.4,0.7h2.2C100.6,22.7,100.4,22.4,100.2,22.3z" />
					<path style="fill:#FFFFFF;" d="M105.6,22.2c-0.4,0-0.7,0.1-0.9,0.4s-0.3,0.7-0.3,1.2V26h-1.4v-5h1.4v0.7c0.2-0.2,0.4-0.4,0.7-0.5
						s0.5-0.2,0.8-0.2v1.3L105.6,22.2L105.6,22.2z" />
				</g>
				<path style="fill:#818BDD;" d="M12.8,11.9c-1.6,1.4-3.4,2.2-5.4,2.2c-2.1,0-3.8-0.6-5.2-1.9S0,9.2,0,7s0.6-3.9,2.1-5c1.4-1.3,3-1.9,4.9-1.9
					c1.8,0,3.5,0.5,4.8,1.7s1.9,2.7,1.9,4.7v2.1h-10C3.8,9.4,4.2,9.9,5,10.4C5.5,10.9,6.4,11,7.2,11c1.3,0,2.5-0.4,3.2-1.3L12.8,11.9z
					 M9.2,3.8C8.7,3.4,8,3.2,7.2,3.2S5.8,3.5,5.2,3.8c-0.6,0.4-1,1-1,1.8h6C9.9,4.9,9.7,4.2,9.2,3.8z" />
			</g>
		</svg>
	</span>
</a>
<button type="button" pmd-btn-fab color="secondary" pmdRipple size="sm" class="p-0 m-0 close-icon"
	(click)="closeSidebar()">
	<i class="material-icons md-white">close</i>
</button>

<ul pmd-collapse class="nav flex-column pmd-sidebar-nav">

	<li class="nav-item" theme="bootstrap4" container="body" pmdTooltip="Dashboard" placement="right">
		<a class="nav-link" (click)="changePage('dashboard')" [ngClass]="{'active': curUrl == 'dashboard' }"
			routerLink="/dashboard">
			<i class="material-icons pmd-nav-icon pmd-icon-sm">speed</i>
			<span class="flex-grow-1">Dashboard</span>
		</a>
	</li>

	<li class="nav-item" theme="bootstrap4" container="body" pmdTooltip="Job Cards" placement="right">
		<a href="javascript:void(0)" (click)="JobCardSubmenu.toggle()" class="nav-link">
			<i class="material-icons pmd-nav-icon pmd-icon-sm">receipt</i>
			<span class="flex-grow-1">Job Cards</span>
		</a>
		<ul pmdCollapse #JobCardSubmenu="pmd-collapse">
			<li class="nav-item">
				<a class="nav-link" (click)="changePage('jobcards')" routerLinkActive='active'
					routerLink="/jobcard/list">
					Job Card List
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" (click)="changePage('add-jobcard')" routerLinkActive='active'
					routerLink="/jobcard/add">
					Add Job Card
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" (click)="changePage('edit-jobcard')" routerLinkActive='active'
					routerLink="/jobcard/edit">
					Edit Job Card
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" (click)="changePage('jobcard-blank')" routerLinkActive='active'
					routerLink="/jobcard/blank">
					Job Card Blank State
				</a>
			</li>
		</ul>
	</li>

	<li class="nav-item" theme="bootstrap4" container="body" pmdTooltip="Workers" placement="right">
		<a class="nav-link" routerLinkActive='active' routerLink="/workers">
			<i class="material-icons pmd-nav-icon pmd-icon-sm">people_alt</i>
			<span class="flex-grow-1">Workers</span>
		</a>
	</li>

	<li class="nav-item" theme="bootstrap4" container="body" pmdTooltip="Customers" placement="right">
		<a class="nav-link" routerLinkActive='active' routerLink="/customers">
			<i class="material-icons pmd-nav-icon pmd-icon-sm">supervised_user_circle</i>
			<span class="flex-grow-1">Customers</span>
		</a>
	</li>
	<li class="nav-item" theme="bootstrap4" container="body" pmdTooltip="Login" placement="right">
		<a href="javascript:void(0)" (click)="LoginSubmenu.toggle()" class="nav-link">
			<i class="material-icons pmd-nav-icon pmd-icon-sm">exit_to_app</i>
			<span class="flex-grow-1">Login</span>
		</a>
		<ul pmdCollapse #LoginSubmenu="pmd-collapse">
			<li class="nav-item">
				<a class="nav-link" routerLinkActive='active' routerLink="/login">
					Login Option 1
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" routerLinkActive='active' routerLink="/login1">
					Login Option 2
				</a>
			</li>
		</ul>
	</li>

	<li class="nav-item" theme="bootstrap4" container="body" pmdTooltip="Notifications" placement="right">
		<a class="nav-link" routerLinkActive='active' routerLink="/notifications">
			<i class="material-icons pmd-nav-icon pmd-icon-sm">notifications</i>
			<span class="flex-grow-1">Notifications</span>
		</a>
	</li>
	<li class="nav-item" theme="bootstrap4" container="body" pmdTooltip="Mail Box" placement="right">
		<a class="nav-link" routerLinkActive='active' routerLink="/mailbox">
			<i class="material-icons pmd-nav-icon pmd-icon-sm">email</i>
			<span class="flex-grow-1">Mail Box</span>
		</a>
	</li>
	<li class="nav-item" theme="bootstrap4" container="body" pmdTooltip="Email Templates" placement="right">
		<a class="nav-link" routerLinkActive='active' routerLink="/email-templates">
			<i class="material-icons pmd-nav-icon pmd-icon-sm">view_quilt</i>
			<span class="flex-grow-1">Email Templates</span>
		</a>
	</li>
	<li class="nav-item" theme="bootstrap4" container="body" pmdTooltip="Other Pages" placement="right">
		<a href="javascript:void(0)" (click)="OtherPages.toggle()" class="nav-link">
			<i class="material-icons pmd-nav-icon pmd-icon-sm">library_books</i>
			<span class="flex-grow-1">Other Pages</span>
		</a>
		<ul pmdCollapse #OtherPages="pmd-collapse">
			<li class="nav-item">
				<a class="nav-link" routerLinkActive='active' routerLink="/about">
					About
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" routerLinkActive='active' routerLink="/typography">
					Typography
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" routerLinkActive='active' routerLink="/iconography">
					Iconography
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" routerLinkActive='active' routerLink="/search-results">
					Search Results
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" routerLinkActive='active' routerLink="/search-no-results-found">
					Search No Results Found
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" routerLinkActive='active' routerLink="/alerts">
					Alerts and Warnings
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" routerLinkActive='active' routerLink="/page-not-found">
					404
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" routerLinkActive='active' routerLink="/page-not-found-with-sidebar">
					404 with Sidebar
				</a>
			</li>
		</ul>
	</li>

	<li class="nav-item" theme="bootstrap4" container="body" pmdTooltip="Settings" placement="right">
		<a class="nav-link" routerLinkActive='active' routerLink="/settings">
			<i class="material-icons pmd-nav-icon pmd-icon-sm">settings</i>
			<span class="flex-grow-1">Settings</span>
		</a>
	</li>

	<li class="nav-item" theme="bootstrap4" container="body" pmdTooltip="FAQs" placement="right">
		<a class="nav-link" routerLinkActive='active' routerLink="/faqs" (click)="changePage('faqs')">
			<i class="material-icons pmd-nav-icon pmd-icon-sm">help</i>
			<span class="flex-grow-1">FAQs</span>
		</a>
	</li>
</ul> -->

<a class="navbar-brand d-none d-xl-block me-0" href="javascript:void(0)"><img src="assets/images/logo-white.svg"
		height="40"></a>

<ul pmd-collapse class="nav flex-column pmd-sidebar-nav">

	<li class="nav-item">
		<a class="nav-link" (click)="changePage('dashboard')" [ngClass]="{'active': curUrl == 'dashboard' }"
			routerLink="/dashboard">
			<i class="material-icons pmd-list-icon pmd-icon-sm">speed</i>
			<span class="flex-grow-1">Dashboard</span>
		</a>
	</li>

	<li class="nav-item">
		<a href="javascript:void(0)" (click)="JobCardSubmenu.toggle()" class="nav-link">
			<i class="material-icons pmd-list-icon pmd-icon-sm">receipt</i>
			<span class="flex-grow-1">Job Cards</span>
		</a>
		<ul pmdCollapse #JobCardSubmenu="pmd-collapse">
			<li class="nav-item">
				<a class="nav-link" (click)="changePage('jobcards')" routerLinkActive='active'
					routerLink="/jobcard/list">
					Job Card List
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" (click)="changePage('add-jobcard')" routerLinkActive='active'
					routerLink="/jobcard/add">
					Add Job Card
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" (click)="changePage('edit-jobcard')" routerLinkActive='active'
					routerLink="/jobcard/edit">
					Edit Job Card
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" (click)="changePage('jobcard-blank')" routerLinkActive='active'
					routerLink="/jobcard/blank">
					Job Card Blank State
				</a>
			</li>
		</ul>
	</li>

	<li class="nav-item">
		<a class="nav-link" routerLinkActive='active' routerLink="/workers">
			<i class="material-icons pmd-list-icon pmd-icon-sm">people_alt</i>
			<span class="flex-grow-1">Workers</span>
		</a>
	</li>

	<li class="nav-item">
		<a class="nav-link" routerLinkActive='active' routerLink="/customers">
			<i class="material-icons pmd-list-icon pmd-icon-sm">supervised_user_circle</i>
			<span class="flex-grow-1">Customers</span>
		</a>
	</li>
	<li class="nav-item">
		<a href="javascript:void(0)" (click)="LoginSubmenu.toggle()" class="nav-link">
			<i class="material-icons pmd-list-icon pmd-icon-sm">exit_to_app</i>
			<span class="flex-grow-1">Login</span>
		</a>
		<ul pmdCollapse #LoginSubmenu="pmd-collapse">
			<li class="nav-item">
				<a class="nav-link" routerLinkActive='active' routerLink="/login">
					Login Option 1
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" routerLinkActive='active' routerLink="/login1">
					Login Option 2
				</a>
			</li>
		</ul>
	</li>

	<li class="nav-item">
		<a class="nav-link" routerLinkActive='active' routerLink="/notifications">
			<i class="material-icons pmd-list-icon pmd-icon-sm">notifications</i>
			<span class="flex-grow-1">Notifications</span>
		</a>
	</li>
	<li class="nav-item">
		<a class="nav-link" routerLinkActive='active' routerLink="/mailbox">
			<i class="material-icons pmd-list-icon pmd-icon-sm">email</i>
			<span class="flex-grow-1">Mail Box</span>
		</a>
	</li>
	<li class="nav-item">
		<a class="nav-link" routerLinkActive='active' routerLink="/email-templates">
			<i class="material-icons pmd-list-icon pmd-icon-sm">view_quilt</i>
			<span class="flex-grow-1">Email Templates</span>
		</a>
	</li>
	<li class="nav-item">
		<a href="javascript:void(0)" (click)="OtherPages.toggle()" class="nav-link">
			<i class="material-icons pmd-list-icon pmd-icon-sm">library_books</i>
			<span class="flex-grow-1">Other Pages</span>
		</a>
		<ul pmdCollapse #OtherPages="pmd-collapse">
			<li class="nav-item">
				<a class="nav-link" routerLinkActive='active' routerLink="/about">
					About
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" routerLinkActive='active' routerLink="/typography">
					Typography
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" routerLinkActive='active' routerLink="/iconography">
					Iconography
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" routerLinkActive='active' routerLink="/search-results">
					Search Results
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" routerLinkActive='active' routerLink="/search-no-results-found">
					Search No Results Found
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" routerLinkActive='active' routerLink="/alerts">
					Alerts and Warnings
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" routerLinkActive='active' routerLink="/page-not-found">
					404
				</a>
			</li>
			<li class="nav-item">
				<a class="nav-link" routerLinkActive='active' routerLink="/page-not-found-with-sidebar">
					404 with Sidebar
				</a>
			</li>
		</ul>
	</li>

	<li class="nav-item">
		<a class="nav-link" routerLinkActive='active' routerLink="/settings">
			<i class="material-icons pmd-list-icon pmd-icon-sm">settings</i>
			<span class="flex-grow-1">Settings</span>
		</a>
	</li>

	<li class="nav-item">
		<a class="nav-link" routerLinkActive='active' routerLink="/faqs" (click)="changePage('faqs')">
			<i class="material-icons pmd-list-icon pmd-icon-sm">help</i>
			<span class="flex-grow-1">FAQs</span>
		</a>
	</li>
</ul>